import { Transition } from "@headlessui/react";

import StayCard from "components/StayCard/StayCard2";
import { ListingDataType } from "data/types";
import React, { FC, Fragment } from "react";
import { useState } from "react";

export interface AnyReactComponentProps {
  className?: string;
  listing?: ListingDataType;
  isSelected?: boolean;
  lat: number;
  lng: number;
  propertyDetail: (info: any) => void;
}

const AnyReactComponent2: FC<AnyReactComponentProps> = ({
  className = "",
  listing,
  isSelected,
  propertyDetail
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const handleClick = () => {
    // Call the callback function and pass the information
    //console.log("le di ", listing?.author)
       propertyDetail(listing);
//    console.log("le di handle")
  };

  return (
    <div
      className={`nc-AnyReactComponent relative  ${className}`}
      data-nc-id="AnyReactComponent"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <span
        className={`flex px-2 py-1 rounded-lg bg-white dark:bg-neutral-900 text-sm font-semibold items-center justify-center min-w-max shadow-lg hover:bg-neutral-900 hover:text-white dark:hover:bg-white dark:hover:text-neutral-900 transition-colors ${
          isSelected
            ? "bg-neutral-900 text-white dark:bg-white dark:text-neutral-900"
            : ""
        }`}
      >
        {listing?.price }
      </span>
      <Transition
        show={isOpen}
        as={Fragment}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="absolute z-50 bottom-full pb-3 -left-12 w-[260px] aspect-w-1">
            <StayCard  data={listing} className="shadow-2xl" onButtonClick={handleClick}/>
        </div>
      </Transition>
    </div>
  );
};

export default AnyReactComponent2;